export const ROUTES: Record<string, string> = {
  ROOT: "/",
  WELCOME: "/",
  GET_STARTED: "/get-started",
  SIGN_IN: "/sign-in",
  SELECT_DENTIST: "/",
  CALENDAR: "/",
  REQUESTS: "/requests",
  PROFILE: "/profile",
  NO_INTERNET: "/no-internet",
  UPDATE: "/update",
  MAINTENANCE: "/maintenance",
};
